import { apiClient } from '../../../shared/api/axios-instance'
import type { Promotion, CreatePromotionData, UpdatePromotionData } from '../types/promotion.types'

const mapPromotion = (item: any): Promotion => ({
    id: String(item.id),
    title: item.title,
    subtitle: item.subtitle,
    image_url: item.image_url,
    image_url_resolved: item.image_url_resolved,
    colors: item.colors || [],
    status: item.status || 'active',
    action_url: item.action_url,
    created_at: item.created_at,
    updated_at: item.updated_at,
})

const promotionService = {
    /**
     * Get all promotions
     */
    async getPromotions(): Promise<Promotion[]> {
        const response = await apiClient.get('admin/catalog/promotions')
        return response.data.data.map(mapPromotion)
    },

    /**
     * Create a new promotion
     */
    async createPromotion(data: CreatePromotionData): Promise<Promotion> {
        const response = await apiClient.post('admin/catalog/promotions', data)
        return mapPromotion(response.data.data)
    },

    /**
     * Update a promotion
     */
    async updatePromotion(id: string, data: UpdatePromotionData): Promise<Promotion> {
        const response = await apiClient.put(`admin/catalog/promotions/${id}`, data)
        return mapPromotion(response.data.data)
    },

    /**
     * Delete a promotion
     */
    async deletePromotion(id: string): Promise<void> {
        await apiClient.delete(`admin/catalog/promotions/${id}`)
    },

    /**
     * Upload promotion banner image
     */
    async uploadImage(id: string, file: File): Promise<{ url: string }> {
        const formData = new FormData()
        formData.append('image', file)
        const response = await apiClient.post(
            `admin/catalog/promotions/${id}/image`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        return response.data.data
    },
}

export default promotionService
